import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Feature.css';
import { Container, Row, Col, } from "react-bootstrap";
import our_feature_1 from '../../Assets/svgs/our_feature_1.svg';
import our_feature_2 from '../../Assets/svgs/our_feature_2.svg';
import our_feature_3 from '../../Assets/svgs/our_feature_3.svg';
import our_feature_4 from '../../Assets/svgs/our_feature_4.svg';
import our_feature_5 from '../../Assets/svgs/our_feature_5.svg';
import our_feature_6 from '../../Assets/Images/our_features_6.png';
import feature_arrow_right_btn from '../../Assets/svgs/feature_arrow_right_btn.svg';
import feature_arrow_left_btn from '../../Assets/svgs/feature_arrow_left_btn.svg';
import featureicon_1 from '../../Assets/svgs/featureicon_1.svg';
import featureicon_2 from '../../Assets/svgs/featureicon_2.svg';
import featureicon_3 from '../../Assets/svgs/featureicon_3.svg';
import featureicon_4 from '../../Assets/svgs/featureicon_4.svg';
import featureicon_5 from '../../Assets/svgs/featureicon_5.svg';
import featureicon_6 from '../../Assets/Images/our_feature_icon6.png';
import dull_feature_arrow_left_btn from '../../Assets/svgs/dull_feature_arrow_left_btn.svg';
import dull_feature_arrow_right_btn from '../../Assets/svgs/dull_feature_arrow_right_btn.svg';

const slideData = [
  {
    image: our_feature_1,
    title: 'Centralized Control',
    description: 'Broadcasts real-time schedules for buses, trains, and other transport.',
    icon: featureicon_1,
    alt:'Centralized control content management system in BoostBoard digital signage Pakistan',
  },
  {
    image: our_feature_2,
    title: 'Cloud Storage',
    description: 'Centralizes digital signage management for remote updates, scalability, security, and real-time collaboration.',
    icon: featureicon_2,
    alt:'Cloud storage CMS in BoostBoard digital signage in Pakistan',
  },
  {
    image: our_feature_3,
    title: 'User-Friendly',
    description: 'Simplify content updates across displays for efficient and seamless operation.',
    icon: featureicon_3,
    alt:'User-friendly content management in Boost Board digital signage in Pakistan',
  },
  {
    image: our_feature_4,
    title: 'Text To Speech',
    description: 'Add text-to-speech to digital signage for dynamic audio, enhancing accessibility and engagement.',
    icon: featureicon_4,
    alt:'Text-to-speech feature in Boost Board digital signage content management system',
  },
  {
    image: our_feature_5,
    title: 'Real-Time News',
    description: 'Engage your audience with live news updates on digital signage for enhanced viewer retention.',
    icon: featureicon_5,
    alt:'Laptop screen showing Breaking News, latest news in Boost Board digital signage in Pakistan',
  },
  {
    image: our_feature_6,
    title: 'Compatibility',
    description: 'Seamlessly integrate with Android devices for versatile deployment and ease across digital signage setups.',
    icon: featureicon_6,
    alt:' Laptop screen displaying Android logo, suggesting compatibility in Boost Board digital signage solution in Pakistan',

  },
];
const Feature = () => {
  const swiperRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleSlideChange = () => {
    if (swiperRef.current) {
      setCurrentIndex(swiperRef.current.swiper.activeIndex);
    }
  };

  return (
    <div className="carousel-container slide-container" id="Features">
       <Container>
        <Row>
          <Col md={12}>
            <div className="section-title">
              <h2 className="first_text">
                Why our <span className="second_text">digital signage</span> solution
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
      <Swiper
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true, el: '.custom-pagination' }}
        spaceBetween={30}
        slidesPerView={1}
        onSlideChange={handleSlideChange} 
        ref={swiperRef} 
        navigation={{
          nextEl: '.swiper-button-next-custom',
          prevEl: '.swiper-button-prev-custom',
        }}
      >
        {slideData.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="slide-content">
              <img
                src={slide.image}
                alt={slide.alt}
                className="laptop-image"
              />
              <div className="title-container">
                <img src={slide.icon} alt="icon" className="title-icon" />
                <h3>{slide.title}</h3>
              </div>
              <p>{slide.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="swiper-button-prev-custom ">
        <img
          src={currentIndex === 0 ? dull_feature_arrow_left_btn : feature_arrow_left_btn}
          alt="Previous"
        />
      </div>
      <div className="swiper-button-next-custom ">
        <img
          src={currentIndex === slideData.length - 1 ? dull_feature_arrow_right_btn : feature_arrow_right_btn}
          alt="Next"
        />
      </div>

      <div className="custom-pagination"></div>
    </div>
  );
};

export default Feature;
